<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-bullhorn"></span>Error Logs</div>
    </div>

    <!-- Start Page loader -->
    <div *ngIf="loading">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Page loader -->

    <!-- Start Page content -->
    <div *ngIf="!loading">
        <div class="content">

          <div class="margin-top-16">

            <div class="row margin-top-16">
              <div class="col-md-12">
                <h4>Error Information</h4>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Error
              </div>
              <div class="col-md-8">
                <p>{{errorDetails.errorMessage}}</p>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Username
              </div>
              <div class="col-md-8">
                <p>{{errorDetails.username}}</p>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                On Date (UTC)
              </div>
              <div class="col-md-8">
                <p>{{errorDetails.createdOn}}</p>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Trace Reference
              </div>
              <div class="col-md-8">
                <p>{{errorDetails.traceReference}}</p>
              </div>
            </div>

          </div>
        </div>

        <div class="row margin-top-16">
            <div class="col-md-6"></div>
            <div class="col-md-3">
            </div>
            <div class="col-md-3">
                <button pButton type="button" class="p-button-raised approve full-width" label="Back"
                    (click)="goBack()"></button>
            </div>
        </div>

        <div class="content margin-top-16" *ngIf="errorDetails.posError != null">

            <div class="margin-top-16">

                <div class="row margin-top-16">
                    <div class="col-md-12">
                        <h4>Point-of-Sale Information</h4>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-4 label">
                        POS System
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.possystemId}}</p>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-4 label">
                        HTTP Code
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.httpCode}}</p>
                    </div>
                </div>

                <div class="row margin-top-8" *ngIf="errorDetails.posError.httpReason != null && errorDetails.posError.httpReason.length > 0">
                    <div class="col-md-4 label">
                        HTTP Reason
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.httpReason}}</p>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-4 label">
                        Unique Error Code
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.uniqueCode}}</p>
                    </div>
                </div>

                <div class="row margin-top-8" *ngIf="errorDetails.posError.translatedError != null && errorDetails.posError.translatedError.length > 0">
                    <div class="col-md-4 label">
                        Error Translated
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.translatedError}}</p>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-4 label">
                        Error
                    </div>
                    <div class="col-md-8">
                        <p>{{errorDetails.posError.errorRaw}}</p>
                    </div>
                </div>

            </div>
        </div>

        <div class="content margin-top-16">

          <div class="margin-top-16">

            <div class="row margin-top-16">
              <div class="col-md-12">
                <h4>Technical Information</h4>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Username
              </div>
              <div class="col-md-8">
                <input type="text" class="readyonly-cursor" pInputText [(ngModel)]="errorDetails.username" readonly="readonly" />
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                User Id
              </div>
              <div class="col-md-8">
                <input type="text" class="readyonly-cursor" pInputText [(ngModel)]="errorDetails.userId" readonly="readonly" />
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Partner Id
              </div>
              <div class="col-md-8">
                <input type="text" class="readyonly-cursor" pInputText [(ngModel)]="errorDetails.partnerId" readonly="readonly" />
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Technician Id
              </div>
              <div class="col-md-8">
                <input type="text" class="readyonly-cursor" pInputText [(ngModel)]="errorDetails.technicianId" readonly="readonly" />
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                End Point Url
              </div>
              <div class="col-md-8">
                <input type="text" class="readyonly-cursor" pInputText [(ngModel)]="errorDetails.endPointUrl" readonly="readonly" />
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                End Point Method
              </div>
              <div class="col-md-8">
                <p>{{errorDetails.endPointMethod}}</p>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                End Point Payload
              </div>
              <div class="col-md-8">
                <textarea *ngIf="errorDetails.endPointPayload != null &&



                          errorDetails.endPointPayload.length > 0"


readonly="readonly" type="text" pInputTextarea class="p-fluid readyonly-cursor"
                 
                          [(ngModel)]="errorDetails.endPointPayload"></textarea>

                <p *ngIf="errorDetails.endPointPayload == null || errorDetails.endPointPayload.length <= 0">
                  N/A
                </p>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="errorDetails.bearerToken != null && errorDetails.bearerToken.length > 0">
              <div class="col-md-4 label">
                Request Bearer Token
              </div>
              <div class="col-md-8">
                <textarea readonly="readonly" type="text" pInputTextarea class="p-fluid readyonly-cursor"
                          rows="3" [(ngModel)]="errorDetails.bearerToken"></textarea>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Current Bearer Token
              </div>
              <div class="col-md-8">
                <textarea readonly="readonly" type="text" pInputTextarea class="p-fluid readyonly-cursor"
                          rows="3" [(ngModel)]="currentBearerToken"></textarea>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Stacktrace
              </div>
              <div class="col-md-8">
                <textarea readonly="readonly" type="text" pInputTextarea class="p-fluid readyonly-cursor"
                          rows="8" [(ngModel)]="errorDetails.exception"></textarea>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Method
              </div>
              <div class="col-md-8">
                <textarea *ngIf="errorDetails.method != null && errorDetails.method.length > 0"
                          readonly="readonly" type="text" pInputTextarea class="p-fluid readyonly-cursor" rows="5"
                          [(ngModel)]="errorDetails.method"></textarea>

                <p *ngIf="errorDetails.method == null || errorDetails.method.length <= 0">
                  N/A
                </p>
              </div>
            </div>

          </div>
        </div>

        <div class="content margin-top-16">

            <div class="margin-top-16">

                <div class="row margin-top-16">
                    <div class="col-md-6">
                        <h4>Reproduce Guide - Import</h4>
                    </div>
                    <div class="col-md-3">
                        <button pButton type="button" class="p-button-raised approve full-width" label="Copy Postman cURL"
                        (click)="copyPostmanCURL()"></button>
                    </div>
                    <div class="col-md-3">
                        <button pButton type="button" class="p-button-raised approve full-width" label="Download Postman cURL"
                            (click)="downloadPostmanCURL()"></button>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-12">

                        <ol>
                            <li>Open Postman.</li>
                            <li>Open your workspace.</li>
                            <li>Click on the "Import" button in the top left corner.</li>
                            <li>Select "Copy" or "Download" the cURL command.</li>
                            <li>Import the downloaded cURL file OR paste the cURL command.</li>
                            <li>Click "Import Without Saving" if you don't want to save it.</li>
                            <li>Click "Send" to execute the request.</li>
                            <li>Happy debugging!</li>
                        </ol>

                    </div>
                </div>

            </div>
        </div>

        <div class="content margin-top-16">

            <div class="margin-top-16">

                <div class="row margin-top-16">
                    <div class="col-md-12">
                        <h4>Reproduce Guide - Manual</h4>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-12">

                        <ol>
                            <li>Open Postman.</li>
                            <li>Open your workspace.</li>
                            <li>Click on the "New" button in the top left corner.</li>
                            <li>Select "HTTP" or "Request."</li>
                            <li>Enter a name for your request and choose or create a collection to save it in.</li>
                            <li>In the request editor:
                                <ul>
                                    <li>
                                        Set the HTTP method: Select <strong>{{errorDetails.endPointMethod}}</strong>
                                        from
                                        the dropdown menu next to the URL
                                        field.
                                    </li>
                                    <li>Enter the URL: Paste the <strong>End Point Url</strong> into the URL field.</li>
                                    <li>
                                        Set the Authorization token:
                                        <ul>
                                            <li>Click on the "Authorization" tab.</li>
                                            <li>Set the Auth Type to <strong>Bearer Token</strong> in the dropdown on
                                                the
                                                left.</li>
                                            <li>Paste the <strong>Bearer Token</strong> into the "Token" field
                                                on
                                                the right.</li>
                                        </ul>
                                    </li>
                                    <li *ngIf="errorDetails.endPointMethod != 'GET'">
                                        Set the body (for POST/PUT):
                                        <ul>
                                            <li>If you are sending a POST/PUT request, click on the "Body" tab.</li>
                                            <li>Select "raw" and then choose "JSON" from the dropdown on the right.</li>
                                            <li>Paste the JSON payload from <strong>End Point Payload</strong> into the
                                                text
                                                area.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>

                            <li>Click "Send" to execute the request.</li>
                            <li>Happy debugging!</li>
                        </ol>

                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- End Page content -->

</div>
